// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XoVqd9sE2ZG6pZ8DEpqy {
  width: 100%;
  background-color: var(--footer-top-block-background);
}

.yQqoTVMquUNLpS7RXSDg {
  display: flex;
  max-width: var(--content-column);
  padding: 1.75rem var(--content-padding);
  margin: 0 auto;
}

.pTnZ2k16p0_d3zkX9o9Q {
  width: 1.125rem;
  height: 1.125rem;
  margin-right: 1.25rem;
  margin-top: 0.1875rem;
  z-index: 1;
}

.pUW0JuBDYDWp_BOaMLMv {
  color: var(--white);
  font-weight: var(--footer-top-part-font-weight);
}

@media only screen and
  (min-width: 1024px) and
  (max-width: 1279px) {
  .yQqoTVMquUNLpS7RXSDg {
    padding: 1.75rem var(--content-padding-desktop-small);
  }
}

@media only screen and
  (min-width: 640px) and
  (max-width: 1023px) {
  .yQqoTVMquUNLpS7RXSDg {
    padding: 1.75rem var(--content-padding-tablet);
  }
}

@media only screen and
  (max-width: 639px) {
  .yQqoTVMquUNLpS7RXSDg {
    padding: 1.75rem var(--content-padding-mobile);
  }

  .pTnZ2k16p0_d3zkX9o9Q {
    margin-right: 0.75rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/FooterTopPart/FooterTopPart.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,uCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,eAAW;EACX,gBAAY;EACZ,qBAAkB;EAClB,qBAAe;EACf,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;;;EACE;IACE,qDAAkD;EACpD;AACF;;AAEA;;;EACE;IACE,8CAA2C;EAC7C;AACF;;AAEA;;EACE;IACE,8CAA2C;EAC7C;;EAEA;IACE,qBAAkB;EACpB;AACF","sourcesContent":[".wrapper {\n  width: 100%;\n  background-color: var(--footer-top-block-background);\n}\n\n.footerTopPart {\n  display: flex;\n  max-width: var(--content-column);\n  padding: 28px var(--content-padding);\n  margin: 0 auto;\n}\n\n.icon {\n  width: 18px;\n  height: 18px;\n  margin-right: 20px;\n  margin-top: 3px;\n  z-index: 1;\n}\n\n.text {\n  color: var(--white);\n  font-weight: var(--footer-top-part-font-weight);\n}\n\n@media (--desktop-small) {\n  .footerTopPart {\n    padding: 28px var(--content-padding-desktop-small);\n  }\n}\n\n@media (--tablet) {\n  .footerTopPart {\n    padding: 28px var(--content-padding-tablet);\n  }\n}\n\n@media (--mobile) {\n  .footerTopPart {\n    padding: 28px var(--content-padding-mobile);\n  }\n\n  .icon {\n    margin-right: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `XoVqd9sE2ZG6pZ8DEpqy`,
	"footerTopPart": `yQqoTVMquUNLpS7RXSDg`,
	"icon": `pTnZ2k16p0_d3zkX9o9Q`,
	"text": `pUW0JuBDYDWp_BOaMLMv`
};
export default ___CSS_LOADER_EXPORT___;
